import React from 'react';
import './footer.css';

import Logotipo from '../../img/logotipo.svg';
import Division from '../../img/division.svg';

import { FaTwitter, FaTelegram } from "react-icons/fa";
import { Link } from 'react-router-dom';


const Footer = () => {
  return (
    <div className='meow__footer section__padding'>
      <div className='meow__footer_links'>
        <div className='meow__footer-logo'>
          <img className="meow__footer_logo_img" src={Logotipo} alt="logo"/>
          <h3>Invistementos em ativos digitais <br/> e democratização do mercado<br/> financeiro.</h3>
        </div>
        <div className='meow__footer_firstcolun'>
          <h4>B2Black</h4>
          <a href="https://b2black.com.br/" target="_blank" rel="noopener noreferrer">
          <p>Saiba mais</p>
          </a>
          <Link to="/details/1" className="link">
          <p>Lançamentos</p>
          </Link>
        </div>
        <div className='meow__footer_secondcolun'>
          <h4>Sobre nós</h4>
          <a href="https://meowl-1.gitbook.io/meowlverse-whitepaper/roadmap" target="_blank" rel="noopener noreferrer">
          <p>Fale conosco</p>
          </a>
          <a href="https://meowl-1.gitbook.io/meowlverse-whitepaper/" target="_blank" rel="noopener noreferrer">
          <p>Roadmap</p>  
          </a>
          <Link to="//details/1" className="link">
          <p>Investir</p>
          </Link>
          
        </div>
        <div className='meow__footer_division'>
          <img src={Division} alt='division'/>
        </div>
        <div className='meow__footer_copyright'>
          <p>©2021 B2Black. All rights reserved.</p>
          <ul className='meow__footer_sociallist'>
            <li>
            <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
              </a>
            </li>
            <li>
            <a href="https://t.me/" target="_blank" rel="noopener noreferrer">
              <FaTelegram />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Footer;
